import $ from 'jquery'

class leadership {
	//? 1. describe and create/initiate our object

	constructor() {
		//Verables
		this.events()
	}

	//?events
	events() {
		let myObj = this

		$(document).ready(function () {
			// myObj.leadershipFunction()
			myObj.CEOAnime()
			myObj.EqualHeight()
			myObj.checkWidth()
			if (window.innerWidth > 567) {
				myObj.leadershipFunction()
			} else {
				myObj.mobileAnimation()
			}
		})
	}

	//? 3. methods (functions)

	EqualHeight() {
		$('.sameHeight')

		let divHeight = 0

		$('.sameHeight').each(function (i, obj) {
			//test
			if (divHeight < $(this).height()) {
				divHeight = $(this).height()
				$('.sameHeight').height(divHeight)
			}
			console.log($(this).height())
		})
	}

	checkWidth() {
		let startingW = window.innerWidth
		$(window).resize(function () {
			if (
				window.innerWidth >= startingW + 200 ||
				window.innerWidth >= startingW - 200
			) {
				location.reload()
			}
		})
	}

	CEOAnime() {
		let ceoTL = new TimelineMax()
		ceoTL.from('.featuredImg', 3, { scale: 1.1 })

		/// trigger
		// init controller
		var controller = new ScrollMagic.Controller()
		// build scene
		var scene = new ScrollMagic.Scene({
			triggerElement: '#ceoSpalsh',
			duration: window.innerHeight * 1.5,
			offset: -(window.innerHeight / 2),
		})
			.setTween(ceoTL) // trigger a TweenMax.to tween
			// .addIndicators({ name: '1 (duration: 0)' }) // add indicators (requires plugin)
			.addTo(controller)
	}

	///desktop Animation
	leadershipFunction() {
		let leadershipTL = new TimelineMax()
		leadershipTL
			.add('start', 0)
			.staggerFrom(
				'.zoom-fade',
				0.3,
				{ scale: 0, opacity: 0, ease: 'expo.out' },
				0.2,
				'start'
			)
			.fromTo(
				'.line',
				1,
				{
					clip: 'rect(0px,0px,209px,0px)',
					ease: 'expo.out',
				},
				{
					clip: 'rect(0px,420px,209px,0px)',
					ease: 'expo.out',
				},
				'start'
			)
			.fromTo(
				'.lineTwo',
				1,
				{
					clip: 'rect(500px,0px,0px,00px)',
					ease: 'expo.out',
				},
				{
					clip: 'rect(0px,500px,500px,0px)',
					ease: 'expo.out',
					delay: 0.5,
				},
				'start'
			)
			.fromTo(
				'.lineThree',
				1,
				{
					clip: 'rect(0px,500px,500px,500px)',
					ease: 'expo.out',
				},
				{
					clip: 'rect(0px,500px,500px,0px)',
					ease: 'expo.out',
					delay: 1,
				},
				'start'
			)

		/// trigger
		// init controller
		var controller = new ScrollMagic.Controller()
		// build scene
		var scene = new ScrollMagic.Scene({
			triggerElement: '#company-leadership',
		})
			.setTween(leadershipTL) // trigger a TweenMax.to tween
			// .addIndicators({ name: '1 (duration: 0)' }) // add indicators (requires plugin)
			.addTo(controller)
	}

	mobileAnimation() {
		let leadershipTL = new TimelineMax({ repeat: -1, repeatDelay: 0 })
		leadershipTL
			.timeScale(1.5)
			.from('.panel', 0.3, {
				scale: 0,
				opacity: 0,
				ease: 'expo.out',
			})
			.fromTo(
				'.line',
				1,
				{
					clip: 'rect(0px,0px,209px,0px)',
					ease: 'expo.out',
				},
				{
					clip: 'rect(0px,420px,209px,0px)',
					ease: 'expo.out',
				}
			)
			.fromTo(
				'.line',
				1,
				{
					clip: 'rect(0px,420px,209px,0px)',
					ease: 'expo.out',
				},
				{
					clip: 'rect(0px,0px,209px,0px)',
					ease: 'expo.out',
					delay: 2,
				}
			)
			.to('.panel', 0.3, {
				scale: 0,
				opacity: 0,
				ease: 'expo.out',
			})
			.from('.panelTwo', 0.3, {
				scale: 0,
				opacity: 0,
				ease: 'expo.out',
			})
			.fromTo(
				'.lineTwo',
				1,
				{
					clip: 'rect(500px,0px,0px,00px)',
					ease: 'expo.out',
				},
				{
					clip: 'rect(0px,500px,500px,0px)',
					ease: 'expo.out',
				}
			)
			.fromTo(
				'.lineTwo',
				1,
				{
					clip: 'rect(0px,500px,500px,0px)',
					ease: 'expo.out',
				},
				{
					clip: 'rect(500px,0px,0px,00px)',
					ease: 'expo.out',
					delay: 2,
				}
			)
			.to('.panelTwo', 0.3, {
				scale: 0,
				opacity: 0,
				ease: 'expo.out',
			})
			.from('.panelThree', 0.3, {
				scale: 0,
				opacity: 0,
				ease: 'expo.out',
			})
			.fromTo(
				'.lineThree',
				0.5,
				{
					clip: 'rect(0px,500px,500px,500px)',
					ease: 'expo.out',
				},
				{
					clip: 'rect(0px,500px,500px,0px)',
					ease: 'expo.out',
				}
			)
			.fromTo(
				'.lineThree',
				0.5,
				{
					clip: 'rect(0px,500px,500px,0px)',
					ease: 'expo.out',
				},
				{
					clip: 'rect(0px,500px,500px,500px)',
					ease: 'expo.out',
					delay: 2,
				}
			)
			.to('.panelThree', 0.3, {
				scale: 0,
				opacity: 0,
				ease: 'expo.out',
			})
	}
}

export default leadership
